import { useMemo, useCallback } from "react";

/**
 * Hook de paginación que SIEMPRE usa paginación backend.
 * Cada vez que se llama loadMore, trae más items del backend.
 * 
 * @param {Array} totalItems - Todos los items cargados hasta el momento
 * @param {number} itemsPerPage - Items por página (por defecto 8, solo informativo)
 * @param {number} mockDelayMs - No se usa, mantenido por compatibilidad
 * @param {boolean} backendHasMore - Si el backend tiene más páginas disponibles
 * @param {Function} onLoadMoreFromBackend - Función que carga más items del backend
 * @param {boolean} isLoadingFromBackend - Si está cargando del backend
 */
export function useLoadMorePagination(
  totalItems,
  itemsPerPage = 8,
  mockDelayMs = 2000,
  backendHasMore = false,
  onLoadMoreFromBackend = null,
  isLoadingFromBackend = false
) {
  // Siempre mostrar TODOS los items cargados (sin paginación frontend)
  const visibleItems = useMemo(() => {
    return totalItems;
  }, [totalItems]);

  // Solo verificar si el backend tiene más páginas
  const hasMore = backendHasMore;

  const loadMore = useCallback(async () => {
    // Si ya estamos cargando, no hay más en el backend, o no hay función de carga, no hacer nada
    if (isLoadingFromBackend || !backendHasMore || !onLoadMoreFromBackend) {
      return;
    }

    // Llamar directamente al backend para cargar más items
    await onLoadMoreFromBackend();
  }, [backendHasMore, onLoadMoreFromBackend, isLoadingFromBackend]);

  return { 
    visibleItems, 
    hasMore, 
    isLoading: isLoadingFromBackend, 
    loadMore
  };
}
